module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/logo-页面底部信息.c4d99.png";